import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RegisterRoutingModule } from './register-routing.module';
import { RegisterComponent } from './components/register/register.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MediaRegistreDisplayComponent } from './modals/media-registre-display/media-registre-display.component';
import { MatSelectModule } from '@angular/material/select';
import { SharedModule } from '../../shared/shared/shared.module';
import { OrdermaltaComponent } from './components/custom/ordermalta/ordermalta.component';

@NgModule({
  declarations: [RegisterComponent, RegisterComponent, MediaRegistreDisplayComponent, OrdermaltaComponent],
  imports: [
    CommonModule,
    RegisterRoutingModule,
    MatDividerModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatCardModule,
    MatChipsModule,
    MatSelectModule,
    SharedModule

  ]
})
export class RegisterModule { }
